import { brand } from '../../../theme/themePrimitives';
import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses } from '@mui/material';

// Custom Styled Tooltip
import React from 'react';

const CustomTooltip = styled(({ title, className, children, ...props }: {
    className?: string;
    title: string;
    children: React.ReactElement;
    [key: string]: unknown;
}) => (
    <Tooltip {...props} title={title} classes={{ popper: className }}>{children}</Tooltip>
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: brand[50],
        border: `1px solid ${brand[300]}`,
        color: brand[300],
        fontSize: '14px',
        padding: '10px 12px',
        borderRadius: '8px',
        maxWidth: 260,
        fontWeight: 500,
        whiteSpace: 'pre-line'
    }
}));

export default CustomTooltip;